import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom"
import axios from "axios";
import {LoyaltyTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import FormLabel from '@material-ui/core/FormLabel';
import MUIDataTable from "mui-datatables";
import { NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import MessageBox from "../../../components/MessageBox/MessageBox";
import Paper from '@material-ui/core/Paper';
import NumberFormat from 'react-number-format';
import { findIndex } from "lodash/array";
import LoadingOverlay from 'react-loading-overlay';
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import Input from '@material-ui/core/Input';
const useStyles = makeStyles((theme) => ({
	title: {
		marginTop: 0,
	},
	field: {
		width: "100%",
		marginBottom: "1rem",
	},
	autoComplete: {
		width: "100%",
		marginTop: "0",
		marginBottom: "0.5rem",
	},
	date: {
		width: "100%",
		marginBottom: "1rem",
	},
	buttonContainer: {
		textAlign: "right",
	},
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
	},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
    },
    paperppp: {
        background: "rgb(179,201,60)",
        width:"100%",
        height:"50px",
    },
    formlabelpayment: {
        color:"white",
        margin:"10px",
        float:"right"
    }
}));

const PackageSalesItems = (props) => {
	const classes = useStyles();
	const navid = props.location.pageInfo ? props.location.pageInfo.navid : '';
    const CurrentPage = props.location.pageInfo ? props.location.pageInfo.navname : '';
    const TransactionInformation = props.location.transactionInfo ? props.location.transactionInfo : '';
    const PackageSalesInformation = props.location.selectedpackagesInfo ? props.location.selectedpackagesInfo : '';
    const isCORelease = props.location.isCORelease ? props.location.isCORelease : '';
	//ApiData Component useState SOF
    const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
	const [items_list, loadItemsDropdown] = useState([]);
    const [pointsDetails, setPointsDetails ] = useState({});
    const [defaultLocation,setSelectedWareHouse]=useState({id:TransactionInformation.warehouse,description:TransactionInformation.warehouse_desc});
    const [location_dropdown, loadLocationDropdown] = useState([]);
    //Loading overlay
    const [showOverlay, setShowOverlay] = useState(false);
    const [overLayMsg, setOverlayMsg] = useState(false);
    //Loading overlay EOF
    const headers = {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': process.env.REACT_APP_API_URL,
    };
    const get_warehouse = () => {
		//get data for warehouse/location dropdown
        const formData = new FormData();
        formData.append('form_data', "");
		const apiUrl = process.env.REACT_APP_API_URL+'warehouse';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
			loadLocationDropdown(res.data.warehouse);
		});
	};
	const get_max_ppp = () => {
		const form_data = {
			navid: navid
		}
        const formData = new FormData();
        formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'get_max_ppp';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            if(res.data.success == 1){
                const newData = {...pointsDetails};
                newData['max_ppp']= res.data.max_ppp.productpackagepoints;
                newData['point_five']= parseFloat(res.data.max_ppp.productpackagepoints) + parseFloat(0.5);
                newData['minus_one']= parseFloat(res.data.max_ppp.productpackagepoints) - parseFloat(1);
                setPointsDetails({ ...newData });
            }else{
                setShowMsgBox(true);
                setMsg("Missing navigation ID");
                setMsgType("warning");
                setTimeout(() => {
                    setShowMsgBox(false);
                }, 3000)
            }
		});
    };
    const get_items = () => {
        const formData = new FormData();
        formData.append('form_data', "");
		const apiUrl = process.env.REACT_APP_API_URL+'get_items';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
			loadItemsDropdown(res.data.items);
		});
	};

    const releasepackage = () => {
        setShowOverlay(true);
        setOverlayMsg('Processing Release...');
		//get data for warehouse/location dropdown
		const form_data = {
            hqidno: branchIdNo,
			idno: TransactionInformation.activationcode,
            items_info: TABLE_DATA,
            location_info:TransactionInformation.warehouse
		}
        const formData = new FormData();
        formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'releasecyop_co';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            if(res.data.result.success == 1){
				setShowMsgBox(true);
				setMsg(res.data.result.message);
				setMsgType("success");
				setTimeout(() => {
                    setShowOverlay(false);
                    setOverlayMsg('');
					setShowMsgBox(false);
                    window.location.reload(false);
				}, 3000)
			}else{
				setShowMsgBox(true);
				setMsg(res.data.result.message);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
				}, 3000)
			}
		});
	};
	//ApiData Component useState EOF
	
	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	//Table Settings
	const [TABLE_DATA, setSelectedItemTable] = useState([]);
    const [selectedItem, setSelectedItem] = useState({});
    const [currentSelectedPPP, setCurrentSelectedPPP] = useState(0);
    const [computedPPP, setComputedPPP] = useState({});
    const [updateExistingRec, setupdateExistingRec] = useState(0);
    
    const computePPP = () => {  
        let total_ppp = 0;
        for (let index = 0; index < TABLE_DATA.length; index++) {
		    total_ppp = parseFloat(total_ppp) + parseFloat(TABLE_DATA[index].ppp);
        }
        const newData = {...computedPPP};
        newData['total_ppp']= total_ppp.toFixed(2);
        setComputedPPP({ ...newData });
    }

    const validatePPP = () => {
        if(computedPPP.total_ppp != "" || computedPPP.total_ppp < 0){
            if(computedPPP.total_ppp < pointsDetails.minus_one){
                setShowMsgBox(true);
                setMsg("Insufficient PPP");
                setMsgType("warning");
                setTimeout(() => {
                    setShowMsgBox(false);
                }, 3000);
            }else{
                if(computedPPP.total_ppp > pointsDetails.point_five){
                    setShowMsgBox(true);
                    setMsg("Maximun point value reached");
                    setMsgType("warning");
                    setTimeout(() => {
                        setShowMsgBox(false);
                    }, 3000);
                }else{
                    if(computedPPP.total_ppp >= pointsDetails.minus_one || computedPPP.total_ppp == pointsDetails.max_ppp || computedPPP.total_ppp <= pointsDetails.point_five){
                        if(isCORelease == ""){
                            props.history.push(nextpage);
                        }else{
                            releasepackage();
                        }
                    }else{
                        setShowMsgBox(true);
                        setMsg("Insufficient PPP");
                        setMsgType("warning");
                        setTimeout(() => {
                            setShowMsgBox(false);
                        }, 3000);
                    }
                }
            } 
        }else{
            setShowMsgBox(true);
            setMsg("Please insert item");
            setMsgType("warning");
            setTimeout(() => {
                setShowMsgBox(false);
            }, 3000);
        }
    }

	const onSelectItem = () => {
        computePPP()
        let newData = [...TABLE_DATA];
        const neededKeys = ["id", "itemname", "ppp", "unit", "qty"];
        if(neededKeys.every(key => Object.keys(selectedItem).includes(key))){
            const tempObj = 
            {
                id:selectedItem.id, 
                itemname:selectedItem.itemname, 
                ppp:selectedItem.ppp.toFixed(2),
                unit:selectedItem.unit,
                qty:selectedItem.qty
            }
            if(selectedItem.id == null || selectedItem.id == "" || selectedItem.ppp == ""){
                setShowMsgBox(true);
                setMsg("Please complete all required fields");
                setMsgType("warning");
                setTimeout(() => {
                    setShowMsgBox(false);
                }, 3000);
            }else{
                if(selectedItem.qty == "" || selectedItem.qty <= 0){
                    setShowMsgBox(true);
                    setMsg("Please select atleast 1 item");
                    setMsgType("warning");
                    setTimeout(() => {
                        setShowMsgBox(false);
                    }, 3000);
                }else{
                    let amttoadd = parseFloat(computedPPP.total_ppp) + parseFloat(selectedItem.ppp);
                    //maximum value reached
                    if(parseFloat(amttoadd) > parseFloat(pointsDetails.point_five)){
                        setShowMsgBox(true);
                        setMsg("Maximun point value reached");
                        setMsgType("warning");
                        setTimeout(() => {
                            setShowMsgBox(false);
                        }, 3000);
                    }else{
                        const form_data = {
                            item_obj: newData,
                            itemid:selectedItem.id,
                            branchidno:branchIdNo,
                            addedqty:selectedItem.qty
                        }
                        const formData = new FormData();
				        formData.append('form_data', JSON.stringify(form_data));
                        const apiUrl = process.env.REACT_APP_API_URL+'checkitemdirectinventory';
                        axios.post(apiUrl, formData, {headers:headers}).then((res) => {
                            if(res.data.is_insufficient == "no"){
                                addOrUpdate(newData, tempObj);
                            }else{
                                setShowMsgBox(true);
                                setMsg("Insufficient inventory quantity for the chosen item. You may contact our head office for your repurchase of products.");
                                setMsgType("warning");
                                setTimeout(() => {
                                    setShowMsgBox(false);
                                }, 3000);
                            }
                        });
                    }
                }
            }
        }else{
            setShowMsgBox(true);
            setMsg("Please select atleast 1 item");
            setMsgType("warning");
            setTimeout(() => {
                setShowMsgBox(false);
            }, 3000);
        }
        handleClose();
	};
    //Callback function of onSelectItem
    useEffect(() => {
        computePPP();
    }, [TABLE_DATA]);
    useEffect(() => {
        computePPP();
    }, [updateExistingRec]);
    const addOrUpdate = (array, item) => {
        const i = array.findIndex(_item => _item.id === item.id);
        if (i > -1) {
            let ppp = parseFloat(array[i].ppp) + parseFloat(item.ppp);
            let qty = parseFloat(array[i].qty) + parseFloat(item.qty);
            array[i].ppp = ppp.toFixed(2);
            array[i].qty = qty.toFixed(2);
            setupdateExistingRec(ppp);
        }else{
            array.push(item); setSelectedItemTable([...array]);
        }
        setSelectedItem({});
    }
	const onItemSelectionChange = (event) => {
		const newData = {...selectedItem};
        newData[event.target.name]= event.target.value;
        newData['ppp']= parseFloat(currentSelectedPPP) * parseFloat(event.target.value);
		setSelectedItem({ ...newData });
	};

	const refreshTable = () => {
		const newData = [...TABLE_DATA];
		setSelectedItemTable([...newData]);
	}

	const TABLE_COLUMNS = [
		{
		  name: 'id',
		  label: 'ID',
		}, {
		  name: 'itemname',
		  label: 'Item Name',
		}, {
            name: 'ppp',
            label: 'PPP',
        }, {
            name: 'unit',
            label: 'Unit',
        }, {
            name: 'qty',
            label: 'Qty',
        }
	];
	
	const TABLE_OPTION = {
		filterType: 'checkbox',
		selectableRows: 'single',
		selectableRowsHideCheckboxes: true,
		selectableRowsOnClick: true,
		onRowsDelete: (data) => { updateSelectedItems(data.data[0].dataIndex) },
	};

	const updateSelectedItems = (index) => {
		TABLE_DATA.splice(index, 1);
		refreshTable();
	}
	//Table Settings EOF

	//Modal Settings
	const [open, setOpen] = useState(false);
	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
	//Modal Settings EOF

	//OnLoad Event/Data Fetching SOF
	useEffect(() => {
		get_max_ppp();
        get_items();
        const newData = {...computedPPP};
        newData['total_ppp'] = 0;
        setComputedPPP({ ...newData });
        get_warehouse();
    }, []);
    //OnLoad Event/Data Fetching SOF

	const dropDownItems = {
		options: items_list,
		getOptionLabel: (option) => option.itemname  + ' (' + option.productpoints + ')',
    };
    
	//FormData
	const [prep_data, setData] = useState({});
	//FormData EOF
	const nextpage =  {
		pathname: "/package-sales-payment",
		transactionInfo: TransactionInformation, // your data array of objects
        selectedpackagesInfo:PackageSalesInformation,
        selectedItemsInfo:TABLE_DATA,
		pageInfo: {
			navid: navid,
			navname: CurrentPage
		}
	}

    const NumberKeyTrapper = (e) => {
        var a = [];
        var k = e.which;
        
        for (let i = 48; i < 58; i++){
            a.push(i);
        }    
        
        if (!(a.indexOf(k)>=0)){
            e.preventDefault();
        }
    }
	return (
		!navid ? <Redirect to="/package-sales" /> :
		<div className="page">
            <LoadingOverlay
            active={showOverlay}
            spinner
            text={overLayMsg}
            >
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/package-sales">
						<h4 className="header-title">Package Sales</h4>
					</NavLink>
					<Typography color="textPrimary">{CurrentPage}</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
                <form noValidate autoComplete="off">
					<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
                <Grid container spacing={2} className={classes.root}>
                    <Grid item xs={12}>
                        <Card>
                            <CardContent>
                                <h4 className={classes.title}>Transaction Information</h4>
                                <Grid container>
                                    <Grid item xs={12} sm={6}>
                                        <Grid container>
                                            <Grid xs={12} sm={3}>
                                                <FormLabel>Activation Code:</FormLabel>
                                            </Grid>
                                            <Grid xs={12} sm={9}>
                                                <FormLabel>{TransactionInformation.activationcode}</FormLabel>
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid xs={12} sm={3}>
                                                <FormLabel>Ref Code:</FormLabel>
                                            </Grid>
                                            <Grid xs={12} sm={9}>
                                                <FormLabel>{TransactionInformation.refcode}</FormLabel>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={8}>
						<Grid item xs={12}>
                            <Card>
                                <CardContent>
                                    <h4 className={classes.title}>Product Details</h4>
									<Grid container spacing={2}>
										<Grid xs={12} >
											<div className={classes.button}>
												<Button variant="outlined" color="primary" onClick={handleOpen} className={classes.buttonMarginRight}>
													Add Item
												</Button>
											</div>	
										</Grid>
										<Grid item xs={12}>										
											<MUIDataTable
												title={
													<div>
														<div className="table-title">
															Selected Item
														</div>
													</div>
												}
												id="table-grid"
												data={TABLE_DATA}
												columns={TABLE_COLUMNS}
												options={TABLE_OPTION}
											/>
										</Grid> 
									</Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                    <Grid item xs={4}>
                        <Card>
                            <CardContent>
                                <h4 className={classes.title}>Product Package Point Details</h4>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Paper variant="outlined" className={classes.paperppp}>
                                            
                                        <FormLabel className={classes.formlabelpayment}>
                                            Max PPP: 
                                            <NumberFormat value={pointsDetails.max_ppp} displayType={'text'} decimalScale={2} thousandSeparator={true}/>
                                        </FormLabel>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Paper variant="outlined" className={classes.paperppp}>
                                            <FormLabel className={classes.formlabelpayment}>
                                                Total Entered PPP: 
                                                <NumberFormat value={computedPPP.total_ppp} displayType={'text'} decimalScale={2} thousandSeparator={true}/>
                                            </FormLabel>
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>              
                </Grid>
                <Grid item xs="12" className={classes.buttonContainer}>
                    {isCORelease == "" ? 
                    <Button 
                        variant="contained" 
                        color="primary"
                        onClick={validatePPP}
                        >
                        Next
                    </Button>
                    :
                    <Button 
                        variant="contained" 
                        color="primary"
                        onClick={validatePPP}
                        >
                        Release
                    </Button>
                    }
                </Grid>
                <div>
                    <Modal
                        aria-labelledby="transition-modal-title"
                        aria-describedby="transition-modal-description"
                        className={classes.modal}
                        open={open}
                        onClose={handleClose}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >
                        <Fade in={open}>
                            <div className={classes.paper}>
                                <h4 id="transition-modal-title">Add Item</h4>
                                <form action="" className={classes.root}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={3}>
                                            Item
                                        </Grid>
                                        <Grid item xs={9}>
                                            <Autocomplete
                                                {...dropDownItems}
                                                autoComplete
                                                includeInputInList
                                                className={classes.autoComplete}
                                                name="itemname"
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        margin="normal"
                                                        label="Packages"	
                                                        variant="outlined"
                                                        required="true"
                                                    />
                                                )}
                                                onChange={(event, newValue) => {
                                                    if (!newValue == "" || !newValue == null){
                                                        const newData = {...selectedItem};
                                                        newData['id']= JSON.stringify(newValue.itemid, null, ' ');
                                                        newData['itemname']= newValue.itemname;
                                                        newData['unit']= newValue.unit;
                                                        setCurrentSelectedPPP(newValue.productpoints);
                                                        setSelectedItem({ ...newData });
                                                    }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={3}>
                                            Quantity
                                        </Grid>
                                        <Grid item xs={9}>
                                            <TextField
                                                type="number"
                                                required
                                                name="qty"
                                                label="Quantity"
                                                variant="outlined"
                                                onChange={onItemSelectionChange}
                                                inputProps={{ min: 0, max: 10000 }}
                                                onKeyPress={NumberKeyTrapper}
                                            />
                                        </Grid>
                                    </Grid>
                                    <div className={classes.button}>
                                        <Button
                                            variant="contained"
                                            onClick={handleClose}
                                            className={classes.buttonMarginRight}
                                        >
                                            Close
                                        </Button>
                                        <Button 
                                            variant="contained" 
                                            color="primary"
                                            onClick={onSelectItem}
                                        >
                                            Add
                                        </Button>
                                    </div>
                                </form>
                            </div>
                        </Fade>
                    </Modal>
                </div>
                </form>
            </div>
            </LoadingOverlay>
        </div>
	);
};

export default PackageSalesItems;
